import { linkColors, borderColors } from '../tokens/color';

export const enecoNavlinkOncolorColors = {
  navLinkSecondaryOnColorDefault: linkColors.linkPrimary,
  navLinkSecondaryOnColorHover: linkColors.linkPrimary,
  navLinkSecondaryOnColorFocusOutline: borderColors.borderFocus,
  navLinkTertiaryOnColorDefault: linkColors.linkSecondary,
  navLinkTertiaryOnColorHover: linkColors.linkPrimary,
  navLinkTertiaryOnColorFocusOutline: borderColors.borderFocus,
};

export const navLinkStyledTextUnderline = {
  styledTextUnderline: `100% 2px`,
};
